import {
  GetAiAgentsPayload,
  GetAiAgentAlertsListPayload,
} from 'app/modules/aiAgents/requests';
import { AiAgentTaskContext } from 'app/modules/aiAgents/models';

const BASE = 'aiAgents';
const AI_AGENTS_ENDPOINT = '/v1/ai-agents';
export const AI_AGENTS_QUERY_KEYS = {
  list: (payload: GetAiAgentsPayload) => [
    ...AI_AGENTS_QUERY_KEYS.listAll(),
    payload,
  ],
  listAll: () => [BASE, 'list'],
  aggregateMetrics: () => [BASE, 'metrics'],
  aggregateMetricsPerAgent: (agentId: number) => [BASE, agentId, 'metrics'],
  details: (agentId: number) => [BASE, agentId, 'details'],
  taskList: (agentId: number) => [BASE, agentId, 'tasks'] as const,
  l2CustomTaskMetadata: (context: AiAgentTaskContext) =>
    [BASE, 'l2-custom-task-metadata', context] as const,
  narrativeExampleInputs: (agentId: number) => [
    BASE,
    agentId,
    'tasks',
    'output',
  ],
  getNarrativeInstructions: (
    agentId: number,
    instructionType: string = 'DEFAULT',
  ) => [BASE, 'get-narrative-instructions', agentId, instructionType],
  aiAlertsList: (agentId: number, payload: GetAiAgentAlertsListPayload) => [
    BASE,
    agentId,
    'alerts',
    'list',
    payload,
  ],
} as const;

export const AI_AGENTS_ENDPOINTS = {
  list: () => `${AI_AGENTS_ENDPOINT}/list`,
  aggregateMetrics: () => `${AI_AGENTS_ENDPOINT}/metrics`,
  aggregateMetricsPerAgent: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/metrics`,
  details: (agentId: number) => `${AI_AGENTS_ENDPOINT}/${agentId}`,
  create: () => `${AI_AGENTS_ENDPOINT}/create`,
  edit: (agentId: number) => `${AI_AGENTS_ENDPOINT}/${agentId}/edit`,
  archive: (agentId: number) => `${AI_AGENTS_ENDPOINT}/${agentId}/archive`,
  restore: (agentId: number) => `${AI_AGENTS_ENDPOINT}/${agentId}/restore`,
  taskList: (agentId: number) => `${AI_AGENTS_ENDPOINT}/${agentId}/tasks`,
  l2CustomTaskMetadata: (context: AiAgentTaskContext) =>
    `${AI_AGENTS_ENDPOINT}/l2-custom-task-metadata/${context}`,
  associateInitialTasks: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/associate-initial-tasks`,
  narrativeExampleInputs: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/narrative/example-inputs`,
  getNarrativeInstructions: (agentId: number, instructionType: string) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/narrative/instructions/${instructionType}`,
  generateNarrativePreview: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/narrative/instructions`,
  saveNarrativeInstructions: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/narrative/instructions`,
  deactivateNarrativeInstructions: (
    agentId: number,
    narrativeInstructionsId: number,
  ) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/narrative/instructions/${narrativeInstructionsId}`,
  aiAlertsList: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/alerts/list`,
} as const;
